import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { GetOrganizationRelationsResponseDto } from '@/types/dtos/organizations/response/organization-relation.dto.ts';

export const GET_ORGANIZATION_RELATIONS_QUERY_KEY = 'get-organization-relations';

export type OrganizationRelationsFilters = {
  /** @deprecated Prefer `basicRole` and `elevatedRole`. */
  organizationRole?: string;
  basicRole?: string;
  elevatedRole?: string;
  status?: string;
  kind?: string;
};

export const useGetOrganizationRelationsQuery = (
  organizationId: string | undefined,
  filters: OrganizationRelationsFilters = {},
) => {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [GET_ORGANIZATION_RELATIONS_QUERY_KEY, organizationId, filters],
    queryFn: async () => {
      const token = await getToken();
      return getOrganizationRelations(organizationId!, filters, token ?? '');
    },
    enabled: !!organizationId,
  });
};

export const getOrganizationRelations = async (
  organizationId: string,
  filters: OrganizationRelationsFilters,
  token: string,
): Promise<GetOrganizationRelationsResponseDto> => {
  const params = new URLSearchParams();
  if (filters.organizationRole) params.set('organizationRole', filters.organizationRole);
  if (filters.basicRole) params.set('basicRole', filters.basicRole);
  if (filters.elevatedRole) params.set('elevatedRole', filters.elevatedRole);
  if (filters.status) params.set('status', filters.status);
  if (filters.kind) params.set('kind', filters.kind);
  const qs = params.toString();
  const url = `${import.meta.env.VITE_API_URL}/organizations/${organizationId}/relations${qs ? `?${qs}` : ''}`;
  return sendJSONRequest({ url, method: METHOD.GET, token });
};
